import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Image } from '@chatterbug/aaron'

import iconBookmark from './assets/bookmark.svg'
import iconInvertedBookmark from './assets/inverted_bookmark.svg'

const BUTTON_RESET_STYLES = {
  margin: 0,
  padding: 0,
  border: 0,
  backgroundColor: 'transparent',
  overflow: 'hidden',
}

// we can expand it later with further use cases
const ICONS = {
  bookmark: { checked: iconInvertedBookmark, unchecked: iconBookmark },
}

const ToggleButton = ({
  icon,
  labelCheck,
  labelUncheck,
  checked,
  onToggle,
}) => {
  const label = checked ? labelUncheck : labelCheck
  const onClick = () => onToggle(!checked)

  return (
    <Box
      as="button"
      type="button"
      onClick={onClick}
      sx={{
        ...BUTTON_RESET_STYLES,
        ':hover .toggle-button-icon': {
          backgroundColor: checked ? 'gray95' : 'blue30',
        },
        ':focus': {
          outline: 0,
        },
      }}
    >
      <Flex alignItems="center">
        <Flex
          mr="2x"
          justifyContent="center"
          alignItems="center"
          sx={{
            width: '36px',
            height: '36px',
            borderRadius: 'full',
            transition: 'background,transform 0.2s ease',
            backgroundColor: checked ? 'white100' : 'blue42',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'blue42',
          }}
          className="toggle-button-icon"
        >
          <Image
            src={checked ? ICONS[icon].checked : ICONS[icon].unchecked}
            alt={label}
          />
        </Flex>
        <Box as="span" variant="text.buttonTitle">
          {label}
        </Box>
      </Flex>
    </Box>
  )
}

ToggleButton.propTypes = {
  icon: PropTypes.oneOf(['add', 'bookmark']),
  labelCheck: PropTypes.string.isRequired,
  labelUncheck: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
}

export default ToggleButton
